import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SliderBox } from '../../../molecules/slider-box';
import { SwitchBox } from '../../../molecules/switch-box';
import { useSelector } from '../../../store/utils';
import { Inverter } from '../../../shared';

export const SettingsPvBattery = () => {
  const largeInstallation = useSelector((s) => s.variables.LARGE_INSTALLATION);
  const sofar = useSelector((s) => {
    const inverterConfig = s.variables.INVERTER_CONFIG;
    const inverterConfigArray = Object.values(inverterConfig ?? {});
    return inverterConfigArray[0]?.type === Inverter.SofarSolarRS485;
  });
  const ems1000 = useSelector((s) => {
    const inverterConfig = s.variables.INVERTER_CONFIG;
    const inverterConfigArray = Object.values(inverterConfig ?? {});
    return inverterConfigArray[0]?.type === Inverter.SolaxEMS1000;
  });
  const ems1000pro = useSelector((s) => {
    const inverterConfig = s.variables.INVERTER_CONFIG;
    const inverterConfigArray = Object.values(inverterConfig ?? {});
    return inverterConfigArray[0]?.type === Inverter.SolaxEMS1000PRO;
  });
  return (
    <>
      <SwitchBox
        title={
          <FormattedMessage
            id="settings.photovoltaics.batteryenabled"
            defaultMessage="Baterie nainstalována"
          />
        }
        switchVariableId="PV_BATTERY"
        visibility={{
          variableIds: [
            { variableId: 'PV_ONGRID', reversed: true },
            'PV_INSTALL',
          ],
        }}
        fullWidth
      />
      <SliderBox
        title={
          <FormattedMessage
            id="settings.photovoltaics.batterynominal"
            defaultMessage="Nominální kapacita baterie"
          />
        }
        subtitle={
          <FormattedMessage
            id="settings.photovoltaics.batterynominal_sub"
            defaultMessage="Nutné zadat pouze pro spotové obchodování"
          />
        }
        variableId="PV_BAT_NOMINAL"
        visibility={{
          variableIds: [
            { variableId: 'PV_ONGRID', reversed: true },
            'PV_INSTALL',
            'PV_BATTERY',
          ],
        }}
        opts={{
          style: 'unit',
          unit: 'kilowatt-hour',
          maximumFractionDigits: 0,
          minimumFractionDigits: 1,
        }}
        step={1}
        min={1}
        max={largeInstallation ? 2000 : 200}
      />
      {ems1000 && (
        <SwitchBox
          title={
            <FormattedMessage
              id="settings.photovoltaics.gridchargeenabled"
              defaultMessage="Nabíjení baterie z distribuční sítě povoleno"
            />
          }
          switchVariableId="EMS_GRID_CHARGE_ENABLE"
          visibility={{ variableIds: ['PV_BATTERY', 'PV_BATTERY_CONTROL'] }}
          fullWidth
        />
      )}
      {(sofar || ems1000 || ems1000pro) && (
        <>
          <SliderBox
            title={
              <FormattedMessage
                id="settings.photovoltaics.batterychargingpower"
                defaultMessage="Nabíjecí výkon baterie"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.photovoltaics.batterychargingpower_sub"
                defaultMessage="Výkon pro manuální nabíjení baterie a spotové nabíjení z distribuční sítě"
              />
            }
            variableId="PV_BATTERY_CHARGING_POWER"
            visibility={{
              variableIds: [
                { variableId: 'PV_ONGRID', reversed: true },
                'PV_INSTALL',
                'PV_BATTERY',
              ],
            }}
            opts={{
              style: 'unit',
              unit: 'kilowatt',
              maximumFractionDigits: 0,
            }}
            step={1}
            min={1}
            max={largeInstallation ? 200 : 20}
          />
          <SliderBox
            title={
              <FormattedMessage
                id="settings.photovoltaics.batterydischargingpower"
                defaultMessage="Vybíjecí výkon baterie"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.photovoltaics.batterydischargingpower_sub"
                defaultMessage="Výkon pro spotové vybíjení baterie do distribuční sítě"
              />
            }
            variableId="PV_BATTERY_DISCHARGING_POWER"
            visibility={{
              variableIds: [
                { variableId: 'PV_ONGRID', reversed: true },
                'PV_INSTALL',
                'PV_BATTERY',
              ],
            }}
            opts={{
              style: 'unit',
              unit: 'kilowatt',
              maximumFractionDigits: 0,
            }}
            step={1}
            min={1}
            max={largeInstallation ? 200 : 20}
          />
        </>
      )}
    </>
  );
};
